import React from "react";
import "./Button.css";
import { Link } from "react-router-dom";

const STYLES = ["btn--primary", "btn--outline", "btn--test"];

const SIZES = ["btn--small", "btn--medium", "btn--large"];

export const Button = ({
    children,
    type,
    onClick,
    buttonStyle,
    buttonSize,
    buttonLink,
}) => {
    const top = () => {
        window.scrollTo(0, 0);
    };

    const checkButtonStyle = STYLES.includes(buttonStyle)
        ? buttonStyle
        : STYLES[0];

    const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
        }
        top();
    };

    return (
        <Link to={buttonLink} className="btn-mobile">
            <button
                className={`btn ${checkButtonStyle} ${checkButtonSize}`}
                onClick={handleClick}
                type={type}
            >
                {children}
            </button>
        </Link>
    );
};
